import { API_URL } from '../../../constants';
import makeUrl from '../../utils/makeUrl';
import _fetch from '../../_fetch';

export default function verifyRecaptcha(recaptchaResponse, options = {}) {
  return function withContext(context) {
    const url = makeUrl(API_URL, 'recaptcha/verify', options);

    const config = {
      method: 'POST',
      body: new URLSearchParams({
        recaptchaResponse: recaptchaResponse
      }),
      headers: {
        'Accept': 'application/json;charset=utf-8',
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      },
      ...options.reqConfig
    };

    return _fetch(url, {
      withAuth: false,
      ...options
    }, config)(context);
  };
}
